class CustomProductForm extends HTMLElement {
  constructor() {
    super()
    this.radioOptions = this.querySelectorAll('input[type="radio"]')
    this.submitBtn = this.querySelector('button[type="submit"]')

    if (this.radioOptions.length && this.submitBtn) {
      this.initialize()
    }
  }

  initialize() {
    this.radioOptions.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.setButtonState(radio.dataset.available === 'true')
      })
    })
  }

  setButtonState(isAvailable) {
    if (isAvailable) {
      this.submitBtn.querySelector('span').textContent = '購入する'
      this.submitBtn.disabled = false
    } else {
      this.submitBtn.querySelector('span').textContent = '在庫切れ'
      this.submitBtn.disabled = true
    }
  }
}
customElements.define('custom-product-form', CustomProductForm)
